import React, {FunctionComponent, Fragment} from "react"
import {FilterType} from "@murphy-frontend/web-core/components/FilterControl"
import FilterToggle from "@murphy-frontend/web-core/components/FilterToggle"

interface FilterToggleRowProps {
	filter: FilterType
	onToggleFilter: (filter: FilterType, filterName: string) => void
	filterName: string
}

const FilterToggleRow: FunctionComponent<FilterToggleRowProps> = ({filter, onToggleFilter, filterName}) => {
	return (
		<Fragment>
			{filter.isActive && (
				<FilterToggle
					filterName={filter.displayName}
					key={filter.displayName}
					checked={filter.isActive}
					handleClick={() => onToggleFilter(filter, filterName)}
				/>
			)}
		</Fragment>
	)
}

export default FilterToggleRow
